<template>
    <div class="h-full w-full flex flex-col">
        <SponsorshipOpportunityForm mode="create" :partners-list="partnersList"
            :non-registered-employers-list="nonRegisteredEmployersList" @created="$emit('created')"
            @close="$emit('close')" />
    </div>
</template>

<script>
import SponsorshipOpportunityForm from "./form.vue";
export default {
    name: "post-sponsorship-create",
    props: ["partnersList", "nonRegisteredEmployersList"],
    emits: ["created", "close"],
    components: { SponsorshipOpportunityForm, },
}
</script>